import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: var(--s-4, 1rem);
`;

const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
  min-width: 0;
`;

const IconWrap = styled.span`
  display: flex;
  color: var(--muted);
  flex-shrink: 0;
  svg {
    width: 1em;
    height: 1em;
    font-size: 1.125rem;
  }
`;

const TextGroup = styled.div`
  min-width: 0;
`;

const Title = styled.h3`
  margin: 0;
  font-size: var(--t-base, 0.9375rem);
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.01em;
`;

const Subtitle = styled.div`
  font-size: var(--t-sm, 0.8125rem);
  color: var(--muted);
  margin-top: 2px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
`;

interface ScSectionHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  icon?: React.ReactNode;
  actions?: React.ReactNode;
}

const ScSectionHeader: React.FC<ScSectionHeaderProps> = ({
  title,
  subtitle,
  icon,
  actions,
}) => (
  <Wrapper>
    <TitleGroup>
      {icon && <IconWrap>{icon}</IconWrap>}
      <TextGroup>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TextGroup>
    </TitleGroup>
    {actions && <Actions>{actions}</Actions>}
  </Wrapper>
);

export default ScSectionHeader;
